// Styles for HotelCard go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledHotelCard = styled.div`
  .mini-card-container {
    width: ${toRem(228)};
    border-radius: ${toRem(14)};
  }

  .mobile-mini-card-container {
    width: ${toRem(327)};
    border-radius: ${toRem(14)};
  }

  .mini-card-image {
    width: ${toRem(212)};
    border-radius: ${toRem(8)};
  }

  .mobile-mini-card-image {
    width: ${toRem(111)};
    border-radius: ${toRem(8)};
  }

  .mini-card-img-container {
    position: relative;
  }

  .brand-logo-container {
    position: absolute;
    bottom: ${toRem(16)};
    background: none;
    svg {
      max-height: ${toRem(19)} !important;
    }
  }

  .list-mini-card-container {
    width: ${toRem(343)};
    border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
  }

  .list-mini-card-image {
    width: ${toRem(96)};
    border-radius: ${toRem(5)};
  }

  .m-link-tertiary-button {
    width: fit-content;
  }
`;
